import React from "react";
import Skeleton from "@mui/material/Skeleton";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from "@mui/material";

const HEADER_COLS = ["", "User Name", "Gender", "Age", "Followers", "Category", "", ""];

const MuiTableSkeleton = ({ row = 10 }) => {
  return (
    <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
      <Table aria-label="loading skeleton" sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow sx={{ background: 'linear-gradient(135deg, #1C1C2E 0%, #2D1A5E 100%)' }}>
            {HEADER_COLS.map((col, i) => (
              <TableCell
                key={i}
                sx={{
                  borderBottom: 'none',
                  color: 'white',
                  fontWeight: 700,
                  fontFamily: 'Lato',
                  fontSize: '0.82rem',
                  letterSpacing: 0.4,
                  py: 1.5,
                }}
              >
                {col}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(row)].map((_, rowIndex) => (
            <TableRow
              key={rowIndex}
              sx={{
                borderBottom: '0.5px solid rgba(0,0,0,0.06)',
                animationDelay: `${rowIndex * 0.04}s`,
              }}
            >
              {/* Checkbox */}
              <TableCell sx={{ width: '5%', borderBottom: 'none', py: 1 }}>
                <Skeleton variant="rectangular" width={18} height={18} sx={{ borderRadius: 0.5 }} />
              </TableCell>
              {/* Avatar + username */}
              <TableCell sx={{ width: '15%', borderBottom: 'none', py: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Skeleton variant="circular" width={30} height={30} sx={{ bgcolor: 'rgba(255,82,0,0.12)', flexShrink: 0 }} />
                  <Skeleton variant="text" width={90} height={18} sx={{ bgcolor: 'rgba(0,0,0,0.07)' }} />
                </Box>
              </TableCell>
              {/* Gender */}
              <TableCell sx={{ width: '10%', borderBottom: 'none', py: 1 }}>
                <Skeleton variant="circular" width={25} height={25} sx={{ bgcolor: 'rgba(0,0,0,0.07)' }} />
              </TableCell>
              {/* Age */}
              <TableCell sx={{ width: '10%', borderBottom: 'none', py: 1 }}>
                <Skeleton variant="text" width={28} height={18} sx={{ bgcolor: 'rgba(0,0,0,0.07)' }} />
              </TableCell>
              {/* Followers */}
              <TableCell sx={{ width: '15%', borderBottom: 'none', py: 1 }}>
                <Skeleton variant="text" width={60} height={18} sx={{ bgcolor: 'rgba(0,0,0,0.07)' }} />
              </TableCell>
              {/* Category */}
              <TableCell sx={{ width: '15%', borderBottom: 'none', py: 1 }}>
                <Skeleton variant="rounded" width={80} height={22} sx={{ bgcolor: 'rgba(255,82,0,0.1)', borderRadius: '20px' }} />
              </TableCell>
              {/* Contact button */}
              <TableCell sx={{ width: '15%', borderBottom: 'none', py: 1 }}>
                <Skeleton variant="rounded" width={100} height={24} sx={{ bgcolor: 'rgba(255,82,0,0.08)', borderRadius: '20px' }} />
              </TableCell>
              {/* Actions */}
              <TableCell sx={{ width: '10%', borderBottom: 'none', py: 1 }}>
                <Skeleton variant="circular" width={28} height={28} sx={{ bgcolor: 'rgba(0,0,0,0.07)' }} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MuiTableSkeleton;
